// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DAuc","placeholdersHeader":"styles_placeholdersHeader__3dBOE","editorStyle":"styles_editorStyle__2YwL_","placeholdersBox":"styles_placeholdersBox__32gZT"};